import { useEffect, useMemo, useState } from "react";

const CustomSettingTypeValue = ({
    _id,
    customSettingTypeValue,
    customSettingTypeId,
    initialTypeValue = {},
    validator,
    update,
    renderActionButton,
    customValuesInUse,
    customSettingTypeName,
    permissions
}) => {
    const [disabled, setDisabled] = useState(false);

    const [currentSequence, setCurrentSequence] = useState(customSettingTypeValue.sequence);
    const [currentValue, setCurrentValue] = useState(customSettingTypeValue.value);

    useEffect(() => {
        let typeValues = [];

        for (const obj in customValuesInUse) {
            typeValues.push(customValuesInUse[obj].value);
        }

        setDisabled(customSettingTypeValue.editable === false || typeValues.includes(_id));
    }, [_id, currentValue, customSettingTypeValue.editable, customValuesInUse]);

    const renderSequence = useMemo(() => {
        return (
            <input disabled={!permissions.update || disabled} type="number" className="form-control form-control-sm px-2 py-1" value={currentSequence} onInput={(event) => update({ fieldType: "CustomSettingTypeValue", newValue: event.target.value, initialValue: initialTypeValue.sequence, changedField: "sequence", _id, customSettingTypeId, setterFunc: setCurrentSequence, customSettingTypeName })} />
        );
    }, [_id, currentSequence, customSettingTypeId, customSettingTypeName, disabled, initialTypeValue.sequence, permissions.update, update]);

    const renderValue = useMemo(() => {
        const fieldValid = `${currentValue}`.trim().length > 0;

        return (
            <input type="string" disabled={!permissions.update || disabled}
                className={`form-control form-control-sm px-2 py-1 ${!fieldValid ? 'border-danger' : ''}`}
                onInput={(event) => {update({ _id, initialValue: initialTypeValue.value, customSettingTypeId, fieldType: "CustomSettingTypeValue", newValue: event.target.value, changedField: "value", sequence: initialTypeValue.sequence, setterFunc: setCurrentValue, customSettingTypeName }) }}
                value={currentValue} />
        );
    }, [_id, currentValue, customSettingTypeId, customSettingTypeName, disabled, initialTypeValue.sequence, initialTypeValue.value, permissions.update, update]);

    useEffect(() => {
        (typeof currentValue === "string") && validator({ _id, field: 'value', fieldValid: currentValue.trim().length > 0 });
    }, [_id, currentValue, validator]);

    const renderCustomSettingTypeValue = useMemo(() => {
        return (
            <div className="row align-items-center mt-2 flex-grow-1 setting-row" key={initialTypeValue._id}>

                <div className="col-fixed-5">
                    {renderSequence}
                </div>
                <div className="col-9">
                    {renderValue}
                </div>
                <span className="col d-flex justify-content-end">
                    {
                        !permissions.update || disabled
                            ? null
                            : renderActionButton({ actionType: 'delete', fieldType: "CustomSettingTypeValue", _id, groupingId: customSettingTypeName })
                    }
                </span>
            </div>
        );
    }, [_id, customSettingTypeName, disabled, initialTypeValue._id, permissions.update, renderActionButton, renderSequence, renderValue]);

    return (
        <>
            {renderCustomSettingTypeValue}
        </>
    );
};

export default CustomSettingTypeValue;